exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Rq8K4C4NP521Au2Hsu_oF{padding:40px 60px}._1Z8JDOGaQTn8oGJ_8nZRo0{color:#757575;height:80px;width:80px;border:2px solid #c8e6dc;border-radius:100%;display:flex;align-items:center;justify-content:center;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"ErrorPage": "_2Rq8K4C4NP521Au2Hsu_oF",
	"icon": "_1Z8JDOGaQTn8oGJ_8nZRo0"
};